import React from "react";
import { S, openConsult } from "../site.js";

function MobileNavIcon({ icon }) {
  const common = {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  if (icon === "home") return (
    <svg {...common}><path d="M3 11.5 12 4l9 7.5" /><path d="M5.5 10.5V20h13v-9.5" /><path d="M9.5 20v-6h5v6" /></svg>
  );
  if (icon === "services") return (
    <svg {...common}><rect x="4" y="4" width="7" height="7" rx="2" /><rect x="13" y="4" width="7" height="7" rx="2" /><rect x="4" y="13" width="7" height="7" rx="2" /><rect x="13" y="13" width="7" height="7" rx="2" /></svg>
  );
  return (
    <svg {...common}><circle cx="12" cy="8" r="3.5" /><path d="M5 20c1.3-4 3.7-6 7-6s5.7 2 7 6" /></svg>
  );
}

function MobileAITypewriter() {
  const prompts = [
    "Ask Next AI...",
    "How can AI help my business?",
    "I want to improve a workflow.",
  ];
  const [text, setText] = React.useState("");

  React.useEffect(() => {
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      setText(prompts[0]);
      return undefined;
    }

    let promptIndex = 0;
    let characterIndex = 0;
    let deleting = false;
    let timer = null;
    let stopped = false;

    const run = () => {
      if (stopped || document.visibilityState !== "visible") return;
      const prompt = prompts[promptIndex];
      if (!deleting) {
        characterIndex += 1;
        setText(prompt.slice(0, characterIndex));
        if (characterIndex === prompt.length) {
          deleting = true;
          timer = window.setTimeout(run, 1500);
          return;
        }
        timer = window.setTimeout(run, 48);
        return;
      }

      characterIndex -= 1;
      setText(prompt.slice(0, characterIndex));
      if (characterIndex === 0) {
        deleting = false;
        promptIndex = (promptIndex + 1) % prompts.length;
        timer = window.setTimeout(run, 360);
        return;
      }
      timer = window.setTimeout(run, 28);
    };

    const resume = () => {
      if (document.visibilityState === "visible" && !timer) run();
    };
    const pause = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") resume();
      else pause();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    run();
    return () => {
      stopped = true;
      pause();
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return <span className="mobile-ai-composer-label" aria-hidden="true">{text}<i /></span>;
}

export function MobileBottomNav({ page = "home" }) {
  const items = [
    { key: "home", label: "Home", href: "/", icon: "home", active: page === "home" },
    { key: "services", label: "Services", href: S.services, icon: "services", active: page === "services" || page === "service" },
  ];

  // The typewriter text is a placeholder, not a draft: open with an empty,
  // focused composer and send nothing (issue #66).
  const askConsultant = openConsult({ focusComposer: true, source: "mobile-nav" });

  return (
    <nav className="mobile-app-nav" aria-label="Primary mobile navigation">
      <div className="mobile-app-nav-shell">
        {items.map((item) => <a key={item.key} className={"mobile-app-nav-item" + (item.active ? " is-active" : "")} href={item.href} aria-label={item.label} aria-current={item.active ? "page" : undefined}><MobileNavIcon icon={item.icon} /></a>)}
        <button type="button" className="mobile-ai-composer" onClick={askConsultant} aria-label="Ask Next AI consultant">
          <MobileAITypewriter /><i aria-hidden="true">↑</i>
        </button>
      </div>
    </nav>
  );
}
